import { GetGroupPurchaseRespone, GroupPurchaseRecipient } from "api"
import {
  Dispatch,
  FC,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react"

export type GroupCardContextType = {
  setGroupCard: Dispatch<SetStateAction<{}>>
  groupCard: GetGroupPurchaseRespone
  currentRecipientData: GroupPurchaseRecipient
  setCurrentRecipientData: Dispatch<SetStateAction<{}>>
  scheduleTime: string | null
  setScheduleTime: Dispatch<SetStateAction<string>>
}

export const GroupCardContext = createContext<GroupCardContextType>(null)

export const GroupCardContextProvider: FC = ({ children }) => {
  const [groupCard, setGroupCard] = useState(null)
  const [currentRecipientData, setCurrentRecipientData] =
    useState<GroupPurchaseRecipient>()
  const [scheduleTime, setScheduleTime] = useState<string | null>(null)

  return (
    <GroupCardContext.Provider
      value={{
        groupCard,
        setGroupCard,
        currentRecipientData,
        setCurrentRecipientData,
        scheduleTime,
        setScheduleTime,
      }}
    >
      {children}
    </GroupCardContext.Provider>
  )
}

export const useGroupCardContext = () => useContext(GroupCardContext)
